// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
    background: white;
    border: 1px solid #E8E8E8;
    border-radius: 6px;
    padding:  40px 17px;
}

.menu {
    border-bottom: 1px solid #E8E8E8;
}

.menu p {
    font-size: 18px;
    color: #797979;
    font-weight: 500;
    margin: 0 0 6px 0;
    cursor: pointer;
    margin-bottom: 13px;
    padding-top: 3px;
}

.main .active {
    border-top: 3px solid rgba(108, 47, 187, 1);
    color: rgba(108, 47, 187, 1);
}

.templateValue{
    background-color: white;
    border: 1px solid #E8E8E8;
    border-radius: 8px;
    text-align: center;
    font-weight: 500;
    padding: 0 15px;
    cursor: pointer;
}

.templateValue p{
    color: #6125AF;
    font-size: 20px;
    padding: 7px 0;
    border-bottom: 1px solid #E8E8E8;
}

.templateValue h5{
    color: black;
    padding: 20px 0;
}

.grabbable{
    cursor: -webkit-grab;
}
.actionButton{
    text-align: end;
}

.actionButton button{
    background-color: #6125AF;
    color: white;
    border: none;
    margin-right: 10px;
    padding: 4px 10px;
    border-radius: 5px;
    font-size: 15px;
}

.btnCreateVideo{
    background-color: #6125AF;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 5px;
    font-size: 15px;
    margin-top: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/upload-template-videos/upload-template-videos.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".main {\n    background: white;\n    border: 1px solid #E8E8E8;\n    border-radius: 6px;\n    padding:  40px 17px;\n}\n\n.menu {\n    border-bottom: 1px solid #E8E8E8;\n}\n\n.menu p {\n    font-size: 18px;\n    color: #797979;\n    font-weight: 500;\n    margin: 0 0 6px 0;\n    cursor: pointer;\n    margin-bottom: 13px;\n    padding-top: 3px;\n}\n\n.main .active {\n    border-top: 3px solid rgba(108, 47, 187, 1);\n    color: rgba(108, 47, 187, 1);\n}\n\n.templateValue{\n    background-color: white;\n    border: 1px solid #E8E8E8;\n    border-radius: 8px;\n    text-align: center;\n    font-weight: 500;\n    padding: 0 15px;\n    cursor: pointer;\n}\n\n.templateValue p{\n    color: #6125AF;\n    font-size: 20px;\n    padding: 7px 0;\n    border-bottom: 1px solid #E8E8E8;\n}\n\n.templateValue h5{\n    color: black;\n    padding: 20px 0;\n}\n\n.grabbable{\n    cursor: -webkit-grab;\n}\n.actionButton{\n    text-align: end;\n}\n\n.actionButton button{\n    background-color: #6125AF;\n    color: white;\n    border: none;\n    margin-right: 10px;\n    padding: 4px 10px;\n    border-radius: 5px;\n    font-size: 15px;\n}\n\n.btnCreateVideo{\n    background-color: #6125AF;\n    color: white;\n    border: none;\n    padding: 8px 20px;\n    border-radius: 5px;\n    font-size: 15px;\n    margin-top: 18px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
